import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import { Text, Title } from 'components';
import { fundamentoLegaleFormat, listToString } from 'utils/formatters';
import Skeletons from './SkeletosWrappers';

const { SkeletonWrapperText } = Skeletons;

const InformacionGeneral = ({ loading, plantilla }) => (
  <>
    <Row justify="center">
      <Title $accent level={3}>
        {plantilla?.nombre}
      </Title>
    </Row>
    <br />
    <ul>
      {plantilla?.ambito_de_ordenamiento && (
        <li>
          <SkeletonWrapperText
            accent
            bold
            wrap
            loading={loading}
            dataLabel="Ámbito del trámite"
          >
            {plantilla?.ambito_de_ordenamiento}
          </SkeletonWrapperText>
        </li>
      )}
      <li>
        <SkeletonWrapperText
          accent
          bold
          wrap
          loading={loading}
          dataLabel="Plazo de respuesta"
        >
          {plantilla?.plazo_real ? plantilla.plazo_real.replace(/ o /g, ' a ') : 'No aplica'}
        </SkeletonWrapperText>
      </li>
      <li>
        <SkeletonWrapperText
          accent
          bold
          wrap
          loading={loading}
          dataLabel="Vigencia"
        >
          {plantilla?.vigenciaLabel || 'No aplica'}
        </SkeletonWrapperText>
      </li>
      <li>
        <SkeletonWrapperText
          accent
          bold
          wrap
          loading={loading}
          dataLabel="Tipo de ficta"
        >
          {plantilla?.tipoDeFictaLabel}
        </SkeletonWrapperText>
      </li>
      {plantilla?.tipos_de_persona_interesadas && (
        <li>
          <SkeletonWrapperText
            accent
            bold
            wrap
            loading={loading}
            dataLabel="Tipo de personas que pueden realizar el trámite"
          >
            {plantilla?.tipos_de_persona_interesadas}
          </SkeletonWrapperText>
        </li>
      )}
      { plantilla?.casos_de_presentacion && (
        <li>
          <SkeletonWrapperText
            accent
            bold
            wrap
            loading={loading}
            dataLabel="¿En qué casos se puede presentar el trámite?"
          >
            {plantilla?.casos_de_presentacion}
          </SkeletonWrapperText>
        </li>
      )}
      {!!plantilla?.documento_de_salida_de_tramite?.length && (
        <li>
          <SkeletonWrapperText
            accent
            bold
            loading={loading}
            dataLabel="Resultado del trámite"
            wrap
          >
            {listToString(plantilla
              ?.documento_de_salida_de_tramite?.map((t) => t?.nombre || '') ?? [''])}
          </SkeletonWrapperText>
        </li>
      )}
      {plantilla?.informacion_adicional && (
        <li>
          <SkeletonWrapperText
            accent
            bold
            wrap
            loading={loading}
            dataLabel="Información adicional"
          >
            {plantilla?.informacion_adicional}
          </SkeletonWrapperText>
        </li>
      )}
      {!!plantilla?.fundamento_legal?.length && (
        <li>
          <SkeletonWrapperText
            accent
            bold
            wrap
            loading={loading}
            dataLabel="Fundamento Legal"
          >
            <br />
            <ul>
              {plantilla.fundamento_legal.map((f) => (
                <li key={f.id}>
                  {fundamentoLegaleFormat(f)}
                </li>
              ))}
            </ul>
          </SkeletonWrapperText>
        </li>
      )}
      {plantilla?.plantilla_de_forma_de_pago?.length && (
        <li>
          <SkeletonWrapperText
            accent
            bold
            wrap
            loading={loading}
            dataLabel="Formas de pago"
          >
            <ul>
              {plantilla?.plantilla_de_forma_de_pago?.map((f) => (
                <li key={f.id || f?.descripcion}>
                  <Text $bold>
                    {f?.forma_de_pago?.descripcion}
                  </Text>
                  <br />
                  {f?.descripcion}
                </li>
              ))}
            </ul>
          </SkeletonWrapperText>
        </li>
      )}
    </ul>
  </>
);

InformacionGeneral.propTypes = {
  loading: PropTypes.bool,
  plantilla: PropTypes.shape({
    plantilla_de_forma_de_pago: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
      forma_de_pago: PropTypes.shape({
        id: PropTypes.number,
        descripcion: PropTypes.string,
      }),
    })),
    vigenciaLabel: PropTypes.string,
    tipoDeFictaLabel: PropTypes.string,
    nombre: PropTypes.string,
    ambito_de_ordenamiento: PropTypes.string,
    plazo_real: PropTypes.string,
    tipos_de_persona_interesadas: PropTypes.string,
    casos_de_presentacion: PropTypes.string,
    documento_de_salida_de_tramite: PropTypes.arrayOf(PropTypes.shape({
      descripcion: PropTypes.string,
    })),
    informacion_adicional: PropTypes.string,
    fundamento_legal: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      denominacion: PropTypes.string,
    })),
  }),
};

InformacionGeneral.defaultProps = {
  loading: false,
  plantilla: {},
};

export default InformacionGeneral;
